import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var InvoicePDFRes;
export const InvoicePDFTodo = createAsyncThunk('InvoicePDF', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'invoice_pdf',
            data: {
                "vinvoice_code": data,
           
               
            },
            headers: { "Content-Type": "application/json" }
        })
        return InvoicePDFRes = res.data

    } catch (error) {
        return InvoicePDFRes = error.response.data
    }
})


